// export const domainNameConstant = 'java-test.jmzgo.com'
export const domainNameConstant = 'common.jmzgo.com';

// export const FRONTEND_HOST = 'http://java-test.jmzgo.com/jmz-puhuimall/#' // 测试服因为放到子目录中，router用不了history模式，所以要把router/index 里的mode: 'history',去掉
export const FRONTEND_HOST = 'https://hgfp.jmzgo.com/#';

// 播商友圈接口 测试服
// export const BSYQ_API_BASE_URL = 'http://bsyq.jmzbo.com'
// 播商友圈接口 正式服
export const BSYQ_API_BASE_URL = 'https://www.jmzbo.com';

// 工会接口 测试服
// export const HG_API_BASE_URL = 'http://hgtest.jmzgo.com'
// 工会接口 正式服
export const HG_API_BASE_URL = 'https://hgapp.jmzgo.com';

// 播商友圈前端 测试服
// export const BSYQ_FRONTEND_URL = 'https://java-test-proxy.jmzgo.com/mall-h5/#'
// 播商友圈前端 正式服
export const BSYQ_FRONTEND_URL = 'https://common.jmzgo.com/mall-h5/#';

